import { stepGroups } from '@/features/chat/phase1/stepGroups'
import { sourcePillsFromCitations } from '@/features/chat/phase1/sourcePills'
import {
  isResearchCategory,
  phaseRunningFromState,
} from '@/features/chat/phase1/thoughtPhaseHelpers'
import { publicTimelinePhaseCopy } from '@/features/chat/phase1/publicTimelinePhaseCopy'
import NarrationText from './NarrationText'
import StepGroupRow from './StepGroupRow'
import SourcePills from './thoughtchain/SourcePills'
import ThoughtStep from './thoughtchain/ThoughtStep'

export default function PublicTimelinePhase({
  phase,
  streaming,
  citations = [],
  showConnector = true,
}) {
  const { kind, title, body } = publicTimelinePhaseCopy(phase)
  const running = phaseRunningFromState(phase.state, phase.rows, streaming)
  const pills = isResearchCategory(kind) ? sourcePillsFromCitations(citations) : []
  return (
    <ThoughtStep
      category={kind}
      title={title}
      streaming={streaming}
      running={running}
      completed={phase.state === 'ready'}
      showConnector={showConnector}
    >
      <NarrationText text={body} error={false} />
      {stepGroups(phase.rows).map((group) =>
        group.label === phase.title || group.label === title ? null : (
          <StepGroupRow key={group.id} group={group} streaming={streaming} />
        ),
      )}
      <SourcePills labels={pills} />
    </ThoughtStep>
  )
}
